export const getCarrier = (segments, isOneWay) => {
  if (isOneWay) {
    return 'NA';
  }
  const carriers = segments?.[0]?.carriers;
  if (!carriers || carriers.length === 0) {
    return 'NA';
  }
  const multipleCarriers = carriers.length > 1;
  return multipleCarriers
    ? carriers.map((carrier) => carrier.id).join('-')
    : carriers[0]?.id;
};

export const getTabLabel = (tab) => {
  const tabs = {
    recommended: 'R',
    cheapest: 'C',
    fastest: 'F',
  };
  return tabs[tab] || 'R';
};

export const getRoute = (itinerary) => {
  const legs = itinerary?.legs;
  const departure = legs?.[0]?.segments?.[0]?.departure?.cityIata || 'NA';
  const destination = legs?.[0]?.segments?.[0]?.destination?.cityIata || 'NA';
  return `${departure}-${destination}`;
};
